export default __webpack_public_path__ + "static/media/assets_banner.bea20cb3.png";